module.exports = __webpack_public_path__ + "media/images/riders/TANJA_ZAKEIJ-9d83720a804265bee3f4136d3cb22e64.png";